export const StatusEnum = {
    EVERY_STATUS: "",
    ACTIVE: "active",
    INACTIVE: "inactive",
    INVITED: "invited",
    INVITATION_EXPIRED: "invite_expired",
};
